var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasContent)?_c('td',[(_vm.flagClass)?_c('span',{staticClass:"flag-icon",class:_vm.flagClass}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.content.ip)+"\n")]):_c('td',{domProps:{"innerHTML":_vm._s(_vm.nullHtml)}})}
var staticRenderFns = []

export { render, staticRenderFns }